import { RouteRecordRaw } from "vue-router";

const publicRoutes: Array<RouteRecordRaw> = [];

export default publicRoutes;
